/**
 * Application Entry Point
 * 
 * Initializes React and renders the root application with context providers.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { App } from './App';
import { MusicianProvider } from './hooks/useMusicianConfig';
import reportWebVitals from './reportWebVitals';
import './fonts/GenerationSans.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <MusicianProvider>
      <App />
    </MusicianProvider>
  </React.StrictMode>
);

reportWebVitals();

